import React from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import './ModalGeneral.css';

function ModalGeneral({
  warning = false,
  success = false,
  header,
  title,
  subtitle,
  description,
  children,
  isShow,
  handleShow,
  onHide,
  confirm,
  cancel,
  onClickConfirm,
  onClickCancel = () => {},
  size = 'md',
  backdrop = 'static',
  keyboard = false,
  className = '',
  colorIcon = 'black',
  colorTitle = 'black',
  colorSubtitle = 'black',
  colorDescription = 'black',
  boldDescription = false,
  bgHeader = 'white',
  headerClassName = '',
  ...props
}) {
  return (
    <Modal
      className={`${className} modal-general-custom`}
      show={isShow}
      onHide={
        onHide
          ? onHide
          : () => {
              handleShow(false);
              onClickCancel();
            }
      }
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size={size}
      backdrop={backdrop}
      keyboard={keyboard}>
      <Modal.Header
        closeButton
        className={
          headerClassName
            ? `${headerClassName} modal-general-custom-header`
            : 'modal-general-custom-header'
        }
        style={{
          padding: '1rem 2rem 0',
          backgroundColor: bgHeader,
          color: colorIcon,
          border: 'none'
        }}>
        {/* Contenedor que permite centrar */}
        <div className="modal-header-center-flex">
          {success || warning ? (
            <FontAwesomeIcon
              className="mb-2"
              icon={success ? faCircleCheck : faCircleExclamation}
              style={{ fontSize: '35px' }}
            />
          ) : null}
          <h3
            className="title-modal-st my-0"
            style={{ fontSize: '24px', fontWeight: '700', color: colorTitle }}>
            {title}
          </h3>
          {subtitle && (
            <p
              className="subtitle-modal-st my-0"
              style={{ fontSize: '18px', fontWeight: '700', color: colorSubtitle }}>
              {subtitle}
            </p>
          )}
        </div>
      </Modal.Header>
      <Modal.Body>
        {description && (
          <p
            style={{
              fontSize: '16px',
              fontWeight: boldDescription ? 'normal' : 'bold',
              color: colorDescription
            }}
            className="text-center px-2">
            {description}
          </p>
        )}
        {children && <div className="text-center px-2">{children}</div>}
        <div className="d-flex justify-content-center align-items-center">
          {confirm && (
            <button
              className="btn btn-block yellow mx-0 px-0"
              style={{ width: props.widthBtns ?? '48%', border: 'none' }}
              onClick={onClickConfirm}>
              {confirm}
            </button>
          )}
          {cancel && (
            <button
              className="btn btn-block yellow mx-0 px-0"
              style={{ width: props.widthBtns ?? '48%', border: 'none' }}
              onClick={onClickCancel}>
              {cancel}
            </button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalGeneral;
